<template>
  <div>
    <div class="landing-header blue lighten-5">
      <div class="arrow-vector">
        <div class="arrow-vector-inner">
          <div class="background-shapes__circle-filled"></div>
          <div class="arrow-shape">
            <img src="../assets/arrow.svg" alt=""/>
          </div>
        </div>
      </div>
      <v-container class="py-0 landing-header-inner">
        <v-row>
          <v-col
              cols="11"
              md="7"
              lg="6"
              class="d-flex align-center justify-center flex-column"
          >
            <div class="pt-6 px-4 pa-md-0">
              <h1 class="font-weight-black mb-3">
                <span class="d-inline-block animate-text font-weight-black"
                >Terms Of Service</span
                >
              </h1>
              <p
                  class="font-weight-regular blue-grey--text text--darken-4 headline"
              >

              </p>
            </div>
          </v-col>
          <v-col cols="12" md="5" lg="6">
            <div class="phone">
              <img src="../assets/phone.png" alt=""/>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="section-overview mt-8 mt-md-14 mb-8">
      <v-container style="text-align: left">
        Finlit Media Tech Group Sdn Bhd. (“FMTG” or “we”, “our” or “us”) operates The Coffee Break services, which includes a newsletter and a website (collectively, the “Services”).
        <br><br>
        These Terms of Service form part of the overall “Agreement” between you and us, which also includes:
        <br>
        (1) our Privacy Policy, which explains how we collect and use your information; and
        <br>
        (2) our Shipping, Refunds and Returns Policy, which applies to your subscription payment
        <br><br>
        By using the Services, you agree to be bound by this Agreement.
        <br><br>
        We may modify this Agreement from time to time and such modification will be effective upon posting on the Services. You will be deemed to have agreed to any such modifications by your further use of the Services after any such modification is posted. It is therefore important that you review this Agreement regularly to ensure you are updated as to any changes. If you do not agree with the modifications, please discontinue use of the Services immediately.
        <br><br>

        <h5>1. CONTENT</h5>
        <b>Proprietary Rights</b><br>

        With the exception of content posted by users of the Services (“User Content”), all materials contained on the Services, including all content, and the sound, audio, software, graphics, text and look and feel of the Services, and all trademarks, copyrights, patents and other intellectual property rights related thereto (“Proprietary Materials”), are owned or controlled by FMTG, our subsidiaries or affiliated companies, contributors, our third party licensors, and/or our advertising partners. You may not modify, remove, delete, augment, add to, publish, transmit, participate in the transfer or sale of, create derivative works from, or in any way exploit any Proprietary Materials, or any other protectable aspects of the Services, in whole or in part, unless specifically stated otherwise. Subject to your compliance with this Agreement and any other relevant policies related to the Services, we grant you a non-exclusive, non-transferable, revocable limited license, subject to the limitations herein, to access and use the Services and Proprietary Materials for your own non-commercial entertainment purposes consistent with the intended purpose of the Services. You agree not to use the Services for any other purpose.
        <br><br>
        You may be able to post, upload, or submit content to be made available through the Services (“Your Content”). As a condition of your use of the Services, you grant us a nonexclusive, perpetual, irrevocable, royalty-free, worldwide, transferable, sublicenseable license to access, use, host, cache, store, reproduce, transmit, display, publish, distribute, modify and adapt and create derivative works (either alone or as part of a collective work) from Your Content. You also agree that (a) the other users of the Services shall have the right to comment on and/or tag Your Content and/or to use, publish, display, modify or include a copy of Your Content as part of their own use of the Services, and (b) we have the right to make any of Your Content available to third parties, so that those third parties can distribute, make derivative works of, comment on and/or analyze your Content on other media and services (either alone or as part of a collective work). By posting or submitting Your Content through the Services, you represent and warrant that you have, or have obtained, all rights, licenses, consents, permissions, power and/or authority necessary to grant the rights granted herein for Your Content. You agree that Your Content will not contain material subject to copyright or other proprietary rights, unless you have the necessary permission or are otherwise legally entitled to post the material and to grant us the license described above.
        <br><br>
        <b>Third-Party Content & User Content</b><br>
        You acknowledge that the Services may include content provided by users. Any opinions, advice, statements, judgments, services, offers, or other information that constitutes part of the content expressed or made available by third parties, including content posted by our contributors or User Content, are those of the respective authors and not of FMTG or its affiliates or any of their officers, directors, employees, or agents. While we retain the right to filter or reject User Content and other content posted by third parties, we review User Content and other third party content in a limited gate-keeper fashion and have no obligation to investigate whether any content or other User Content violate any term of this Agreement and will not do so in most cases. We neither endorse nor are responsible for the User Content or any other content posted to the Services by anyone other than FMTG.
        <br><br>
        Just as you retain complete ownership of Your Content (subject to the license to us granted above), all other users of the Services retain ownership of their User Content. You may not modify, remove, delete, augment, add to, publish, transmit, participate in the transfer or sale of, create derivative works from, or in any way exploit any User Content in whole or in part.
        <br><br>
        <h5>2. CONDUCT</h5>
        You, as a user, agree to use the Services only for lawful purposes. Without limiting anything else above, specific prohibited activities include, but are not limited to:<br>
        <ul>
        <li>depicting, encouraging or partaking in criminal or tortious activity, including fraud, trafficking in obscene or illegal material, drug dealing or using, underage drinking, gambling, violence, harassment, stalking, spamming, spimming, sending of viruses or other harmful files,</li>
          <li>depicting, encouraging or partaking in dangerous activities or conduct that is abusive, threatening, obscene, defamatory or libelous;</li>
          <li>posting, uploading or sharing content that violates any of the prohibitions herein or that constitutes copyright infringement, patent infringement, or theft of trade secrets;</li>
          <li>attempting to circumvent, disable or otherwise interfere with security-related features of the Services or features that prevent or restrict use or copying of any content or enforce limitations on use of the Services or the content therein;</li>
          <li>using any software that intercepts, mines, or otherwise collects information about other users or copies and stores any Proprietary Materials (as defined below);</li>
          <li>interfering with, disrupting, or creating an undue burden on the Services or the networks or services connected to the Services;</li>
          <li>attempting to impersonate another user or person;</li>
          <li>soliciting personal information from anyone under 18;</li>
          <li>collecting, harvesting, soliciting or posting personally identifiable information about anyone other than yourself;</li>
          <li>using information obtained from the Services in order to harass, abuse, or harm another person, whether a user or a contributor;</li>
          <li>using the Services a commercial manner.</li>
        </ul>
        <br>
        You represent and warrant that neither your actions on the Services nor Your Content will violate any of the prohibited conduct described above.
        <br><br>
        <h5>3. LINKS</h5>
        The Services may contain links or otherwise direct you to websites operated by third parties. We do not monitor or control the linked sites and make no representations regarding, and are not liable or responsible for the accuracy, completeness, timeliness, reliability or availability of, any of the content uploaded, displayed, or distributed, or products, or services available at these sites. If you choose to access any third party site, you do so at your own risk. The presence of a link to a third party site does not constitute or imply our endorsement, sponsorship, or recommendation of the third party or of the content, products, or services contained on, or available through, the third party site.
        <br><br>
        We reserve the right to disable links to third party sites.
        <br><br>

        <h5>4. CERTAIN SERVICES</h5>
        <b>Subscription</b><br>
        Payment. You acknowledge and agree that all information you provide with regards to a purchase of Offerings, including, without limitation, credit card, PayPal, or other payment information, is accurate, current and complete. You represent and warrant that you have the legal right to use the payment method you provide to us or our payment processor, including, without limitation, any credit card you provide when completing a transaction. To the extent that we are required by law to charge and collect taxes on Offerings, such taxes are charged based on the tax laws applicable to the location to which the order is being shipped or delivered. At checkout, all appropriate taxes will be added to the order total. The tax amount displayed during checkout is an estimate. This amount may vary slightly from the actual amount of tax payable in connection with your order due to different tax rates which apply as a result of the origin and destination of the item(s) being purchased, as well as other factors. When you purchase Offerings, you (a) agree to pay the price for such Offerings as set forth in the applicable Service, and all shipping and handling charges and all applicable taxes in connection with your purchase (the “Full Purchase Amount”), and (b) authorize us to charge your credit card or other payment method for the Full Purchase Amount. Unless otherwise noted, all currency references are in U.S. Dollars. All fees and charges are payable in accordance with payment terms in effect at the time the fee or the charge becomes payable. Payment can be made by credit card, debit card, or through PayPal or other means that we may make available. Orders will not be processed until payment has been received in full, and any holds on your account by any payment processor are solely your responsibility.
        <br>
        <b>Special Promotions</b><br>
        We may offer you the chance to participate in drawings, contests, giveaways, and promotions (“Special Promotions”) through the Services. By registering for a Special Promotion, you agree to the official rules that govern that Special Promotion, which may contain specific requirements of you, including, except where prohibited by law, allowing the sponsor(s) of the Special Promotion to use your name, voice and/or likeness in advertising or marketing associated with the Special Promotion. If you choose to enter a drawing, contest or other promotion, personally identifiable information may be disclosed to third parties or the public in connection with the administration of such Special Promotion, including, without limitation, in connection with winner selection, prize fulfillment, and as required by law or permitted by the Special Promotion’s official rules, such as on a winners list.
        <br><br>
        <h5>5. THIRD-PARTY COMPANIES AND PROVIDERS</h5>
        The Services may enable you to request and receive products, information and services from businesses that are not owned or operated by us. The purchase, payment, warranty, guarantee, delivery, maintenance, and all other matters concerning the merchandise, services or information, opinion or advice ordered or received from such businesses are solely between you and such businesses. We do not endorse, warrant, or guarantee such products, information, or services, and are not liable for the accuracy, completeness, or usefulness of such information or the quality of availability of such products or services. We will not be a party to or in any way be responsible for monitoring any transaction between you and third-party providers of such products, services, or information, or for ensuring the confidentiality of your credit card information. Any separate charges or obligations you incur in your dealings with these third parties are your responsibility and are not part of the fee, if any, charged for the Services.
        <br><br>
        In addition, the Services may prompt you to establish an account with a third party service provider not owned or operated by us. Your agreement and understanding with any such third party service provider is solely between you and such service provider. Any disputes you may encounter with such third party service provider must be settled solely between you and the service provider.
        <br><br>

        <h5>6. DISCLAIMERS AND LIMITATION OF LIABILITY</h5>
        THE SERVICES ARE PROVIDED BY US ON AN "AS IS" AND "AS AVAILABLE" BASIS. TO THE FULLEST EXTENT PERMISSIBLE BY APPLICABLE LAW, WE DISCLAIM ALL IMPLIED WARRANTIES, INCLUDING BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.<br>
        WITHOUT LIMITING THE FOREGOING, NEITHER WE NOR ANY THIRD-PARTY PROVIDER MAKES ANY REPRESENTATION OR WARRANTY OF ANY KIND, EXPRESS OR IMPLIED: (I) AS TO THE OPERATION OF THE SERVICES, OR THE INFORMATION, CONTENT, MATERIALS OR PRODUCTS INCLUDED THEREON; (II) THAT USE OF THE SERVICES WILL BE 100% SECURE, UNINTERRUPTED OR ERROR-FREE; (III) AS TO THE ACCURACY, RELIABILITY, OR CURRENCY OF ANY INFORMATION, CONTENT, OR SERVICE, PROVIDED THROUGH THE SERVICES; OR (IV) THAT THE SERVERS, OR EMAILS SENT FROM OR ON BEHALF OF US, ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
        <br>
        FMTG EXPRESSLY DISCLAIMS ANY AND ALL LIABILITY FOR THE ACTIONS OF ITS USERS OR THE CONTENTS OF ANY USER CONTENT.
        <br>
        WE WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES ARISING FROM THE USE OF THE SERVICES OR THE PURCHASE OF ANY PRODUCT THEREFROM, EVEN IF WE OR SUCH PROVIDER HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. UNDER NO CIRCUMSTANCES WILL WE BE LIABLE TO YOU FOR MORE THAN THE AMOUNT YOU HAVE PAID US IN THE ONE HUNDRED AND EIGHTY (180) DAYS IMMEDIATELY PRECEDING THE DATE ON WHICH YOU FIRST ASSERT ANY SUCH CLAIM, AND IF YOU HAVE NOT PAID ANY AMOUNTS DURING THAT TIME PERIOD, YOU ACKNOWLEDGE THAT YOUR SOLE REMEDY IS TO CEASE USING THE SERVICES AND TERMINATE YOUR ACCOUNT.
        <br><br>
        <h5>7. LEGALITY</h5>
        You are subject to all laws of the state(s) and countries in which you reside and from which you access the Services and are solely responsible for obeying those laws. You agree we cannot be held liable if laws applicable to you restrict or prohibit your participation. We make no representations or warranties, implicit or explicit, as to your legal right to participate in any Services, contests, sweepstakes or tournaments offered through the Services nor will any person affiliated, or claiming affiliation with the Services have authority to make any such representations or warranties.
        <br><br>
        <h5>8. APPLICABLE LAW; JURISDICTION</h5>
        The Services are created and controlled by us in country of Malaysia. As such, the laws of Malaysia will govern this Agreement.
        <br><br>
        Subject to the Binding Arbitration section below, you hereby irrevocably and unconditionally consent to submit to the exclusive jurisdiction Malaysian courts for any litigation arising out of or relating to use of or purchase made through the Services (and agree not to commence any litigation relating thereto except in such courts).
        <br><br>
        <h5>9. INDEMNITY</h5>
        You agree to indemnify and hold FMTG, our subsidiaries and affiliates, and our respective officers, agents, partners and employees, harmless from any loss, liability, claim, or demand, including reasonable attorneys’ fees, made by any third party due to or arising out of your breach of this Agreement and/or any of your representations and warranties set forth herein.
        <br><br>
        <h5>10. SEVERABILITY</h5>
        The provisions of this Agreement are intended to be severable. If for any reason any provision of this Agreement will be held invalid or unenforceable in whole or in part in any jurisdiction, such provision will, as to such jurisdiction, be ineffective to the extent of such invalidity or unenforceability without in any manner affecting the validity or enforceability thereof in any other jurisdiction or the remaining provisions hereof in any jurisdiction.
        <br><br>
        <h5>11. ELECTRONIC COMMUNICATIONS</h5>
        When you use the Services or send emails to us, you are communicating with us electronically. You consent to receive communications from us electronically. We will communicate with you by email or by posting notices through the Services. You agree that all agreements, notices, disclosures and other communications that we provide you electronically satisfy any legal requirement that such communications be in writing.
        <br><br>
        <h5>12. OTHER</h5>
        This Agreement is deemed accepted upon any use of any of the Services. Our failure to exercise or enforce any right or provision of this Agreement will not operate as a waiver of such right or provision. The section titles in this Agreement are for convenience only and have no legal or contractual effect.
        <br><br>
        <h5>13. SUPPORT</h5>
        Subject to the other provisions of this Agreement, we will attempt to help you with any queries or problems that you may have with the Services or any of your purchases through the Services. To reach our customer support team, please e-mail us at breakmycoffee (@) gmail.com. It will expedite your request for assistance by providing our representatives with all the information they need to solve your problem as quickly as possible.
        <br><br>
        <h5>14. MODIFICATION</h5>
        We reserve the right to make changes to the Services, posted policies and this Agreement at any time without notice other than the reposting of the modified Agreement. We will attempt to notify you of material changes by communicating them to you directly (if we have contact information for you), adding temporary banners to the Services or otherwise highlighting such changes.<br>
        Please contact us at breakmycoffee (@) gmail.com with any questions regarding this Agreement.
      </v-container>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$leading: (
    "none": 1,
    "tight": 1.25,
    "snug": 1.375,
    "normal": 1.5,
    "relaxed": 1.625,
    "loose": 2,
);

.testi-links {
  color: #00d4ff;
}

.v-application .caption {
  font-size: medium !important;
}

@each $name, $value in $leading {
  .leading-#{$name} {
    line-height: $value !important;
  }
}

@media (min-width: 1264px) {
  .container {
    max-width: 1185px !important;
  }
}

.v-card__text__height {
  line-height: 1.5em;
  min-height: 7em;
}

.v-card__title {
  word-break: break-word;
}

.content-card {
  word-break: keep-all;

  figure {
    position: relative;

    &:after {
      content: "";
      position: absolute;
      display: block;
      height: 100%;
      width: 100%;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.05) linear-gradient(
              rgba(0, 0, 0, 0),
              rgba(0, 0, 0, 0) 20%,
              rgba(0, 0, 0, 0.85) 100%
      );
      transition-property: all;
      transition-duration: 0.2s;
      transition-timing-function: ease;
    }
  }

  .content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 24px;
  }

  &:hover {
    figure {
      &:after {
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }
}

.landing-header {
  position: relative;
  overflow: hidden;

  &-inner {
    position: relative;
    z-index: 1;
  }

  h1 {
    font-size: 58px;
    line-height: 1;
    @media only screen and (min-width: 600px) {
      font-size: 64px;
      line-height: 1.2;
    }
  }

  p {
    font-size: 21px;
  }

  .animate-text {
    background: linear-gradient(231deg, #083d73, #094879, #00d4ff);
    background-size: 600% 600%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    -webkit-animation: TextGradientAnimation 5s ease infinite;
    -moz-animation: TextGradientAnimation 5s ease infinite;
    animation: TextGradientAnimation 5s ease infinite;
  }
}

.arrow-vector {
  position: absolute;
  width: 100%;
  max-width: 1185px;
  height: 100%;
  left: 50%;
  top: 0;
  transform: translateX(-50%);

  &-inner {
    -webkit-animation: fadein 1s;
    animation: fadein 1s;
    display: grid;
    grid-column: 1/-1;
    grid-row: 1/-1;
    grid-template-areas:
      "topleft topcenter topright"
      "middleleft middlecenter middleright"
      "bottomleft bottomcenter bottomright";
    grid-template-columns: repeat(3, 33.33%);
    grid-template-rows: repeat(3, 33.33%);
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .arrow-shape {
    position: absolute;
    width: 500px;
    bottom: 0;
    z-index: 1;
    transform: rotate(-15deg);
    right: 5px;

    @media only screen and (min-width: 600px) {
      width: 1000px;
      right: 15px;
    }
  }

  .background-shapes__circle-filled {
    background-color: #0093e9;

    background-image: linear-gradient(
            160deg,
            #0093e9 0%,
            rgba(99, 251, 215, 1) 50%,
            #80d0c7 100%
    );
    mix-blend-mode: multiply;

    border-radius: 100%;
    position: relative;
    height: 590px;
    width: 590px;
    transform: translate3d(-30%, -10%, 0);
    grid-area: bottomcenter;
    @media only screen and (min-width: 600px) {
      height: 1090px;
      width: 1090px;
      transform: translate3d(-25%, -20%, 0);
      grid-area: bottomright;
    }
  }
}

.phone {
  max-width: 230px;
  margin: 30px auto;

  img {
    display: block;
    width: 100%;
  }

  @media only screen and (min-width: 600px) {
    max-width: 300px;
    transform: translateY(15%);
    margin: 0 auto;
  }
}

@-webkit-keyframes TextGradientAnimation {
  0% {
    background-position: 0% 88%;
  }
  50% {
    background-position: 100% 13%;
  }
  100% {
    background-position: 0% 88%;
  }
}

@-moz-keyframes TextGradientAnimation {
  0% {
    background-position: 0% 88%;
  }
  50% {
    background-position: 100% 13%;
  }
  100% {
    background-position: 0% 88%;
  }
}

@keyframes TextGradientAnimation {
  0% {
    background-position: 0% 88%;
  }
  50% {
    background-position: 100% 13%;
  }
  100% {
    background-position: 0% 88%;
  }
}

.section {
  &__title {
    display: flex;
    align-items: center;
    margin: 24px 0 20px;

    .icon {
      //width: 48px;
      //height: 48px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 999px;
      margin-right: 6px;

      svg {
        display: block;
        width: 36px;
        height: 36px;
        fill: currentColor;
      }
    }
  }

  &-overview {
    text-align: center;

    p {
      max-width: 700px;
      margin: 0 auto 18px;
      font-size: 16px;
      line-height: 1.6;
      @media (min-width: 768px) {
        font-size: 21px;
        margin: 0 auto 24px;
      }
    }
  }


  &-top {
    margin: 30px 0;
    background-image: linear-gradient(
            0deg,
            #fff 0%,
            rgba(179, 229, 252, 1) 60%,
            #fff 100%
    );
  }
}

.newsletter-form {
  position: relative;
  max-width: 400px;

  .btn-submit {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    padding: calc(0.4rem * 0.75) 12px !important;
    height: auto !important;
  }

  .input {
    position: relative;
    display: block;
    width: 100%;
    font-size: 14px;

    &__label {
      position: absolute;
      left: 0;
      top: 0;
      padding: calc(0.4rem * 0.75) calc(0.875rem * 0.5);
      margin: calc(0.4rem * 0.75 + 3px) calc(0.5rem * 0.5);
      white-space: nowrap;
      transform: translate(0, 0);
      transform-origin: 0 0;
      background: #e3f2fd;
      transition: transform 120ms ease-in;
      font-weight: bold;
      line-height: 1.2;
    }

    &__field {
      box-sizing: border-box;
      display: block;
      width: 100%;
      border: 2px solid currentColor;
      padding: calc(0.4rem * 1.5) 0.875rem;
      padding-right: 100px;
      color: currentColor;
      background: #e3f2fd;
      border-radius: 5px;

      &:focus,
      &:not(:placeholder-shown) {
        & + .input__label {
          transform: translate(0.2rem, -65%) scale(0.8);
          color: #1976d2;
        }
      }
    }
  }
}

// substack iframe
.iframe-container {
  &-header {
    position: relative;
    display: inline-flex;

    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      background: #e3f2fd;
    }

    &:before {
      left: 0;
      width: 12px;
      height: 100%;
      @media (min-width: 768px) {
        width: 17px;
      }
    }

    &:after {
      right: 0;
      width: 17px;
      height: 100%;
    }

    .top,
    .bottom {
      position: absolute;
      width: 100%;
      left: 0;
      right: 0;
      background: #e3f2fd;
    }

    .top {
      top: 0;
      height: 16px;
    }

    .bottom {
      bottom: 0;
      height: 32px;
    }
  }
}

.sns {
  width: 100%;
  //max-width: 700px;
  margin: 32px auto 0;
  padding: 32px 16px;
  background: rgba(0, 0, 0, .1);
  //border-top: 1px solid rgba(0, 0, 0, .2);
  //border-bottom: 1px solid rgba(0, 0, 0, .2);
}

.btn-sns {
  display: inline-flex;
  align-items: center;
  border-radius: 5px;
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
  line-height: 1rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;

  font-size: 16px;
  text-decoration: none;
  color: white;
  font-weight: bold;
  margin: 5px 0;
  transition: opacity .3s;
}

.btn-sns:hover {
  opacity: .9;
}

.btn-facebook {
  background: rgb(24, 119, 242);
  margin-right: 10px;
}

.btn-twitter {
  background: #1DA1F2;
}
</style>

<script>
export default {
  name: "TermsOfService",

  mounted() {
    document.title = "The Coffee Break";
  },
  data() {
    return {
      busy: false,
      email: "",
      errorMessage: "",
      errorBox: false,
      successBox: false,
      successDialog: false,
      rssFeeds: null,
    };
  },
  methods: {
    openLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
